import { render, staticRenderFns } from "./ModelAddMessage.vue?vue&type=template&id=527758a8"
import script from "./ModelAddMessage.vue?vue&type=script&lang=js"
export * from "./ModelAddMessage.vue?vue&type=script&lang=js"
import style0 from "./ModelAddMessage.vue?vue&type=style&index=0&id=527758a8&prod&lang=css&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports